/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_PricingInputs */

const tr_landing_nav_pricing = /** @type {(inputs: Landing_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyatlandırma`)
};

const en_landing_nav_pricing = /** @type {(inputs: Landing_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const de_landing_nav_pricing = /** @type {(inputs: Landing_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise`)
};

const ru_landing_nav_pricing = /** @type {(inputs: Landing_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тарифы`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Landing_Nav_PricingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_nav_pricing = /** @type {((inputs?: Landing_Nav_PricingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_PricingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_nav_pricing(inputs)
	if (locale === "de") return de_landing_nav_pricing(inputs)
	if (locale === "ru") return ru_landing_nav_pricing(inputs)
	return tr_landing_nav_pricing(inputs)
});